var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarkerHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 73,
    height: 72,
    viewBox: "0 0 73 72",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.75 49C43.6536 49 49.25 43.4036 49.25 36.5C49.25 29.5964 43.6536 24 36.75 24C29.8464 24 24.25 29.5964 24.25 36.5C24.25 43.4036 29.8464 49 36.75 49Z",
    fill: "#92D050"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M36.25 61C50.0571 61 61.25 49.8071 61.25 36C61.25 22.1929 50.0571 11 36.25 11C22.4429 11 11.25 22.1929 11.25 36C11.25 49.8071 22.4429 61 36.25 61Z",
    fill: "#92D050"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M36.25 72C56.1323 72 72.25 55.8823 72.25 36C72.25 16.1177 56.1323 0 36.25 0C16.3677 0 0.25 16.1177 0.25 36C0.25 55.8823 16.3677 72 36.25 72Z",
    fill: "#92D050"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerHover);
export default __webpack_public_path__ + "static/media/marker_hover.babaea88c63920518b8bc96b111f8d29.svg";
export { ForwardRef as ReactComponent };